module.exports = __webpack_public_path__ + "static/media/visa_electron.931dfe57.png";